<script setup lang="ts">
// spec/admin-ui/navigation.md: admin-ui-navigation-R18, R24, R32, R53, R54, R88.
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
const auth = useAuthStore()
</script>

<template>
  <div id="app">
    <p v-if="auth.isLoading" role="status">{{ $t('Loading...') }}</p>
    <RouterView v-if="auth.hasWorkspace" />
    <div v-if="auth.notice || auth.canSignIn" role="alert" data-testid="auth-notice" class="auth-notice">
      <p v-if="auth.notice">{{ $t(auth.notice) }}</p>
      <button v-if="auth.canSignIn" type="button" @click="auth.login()">{{ $t('Sign in') }}</button>
    </div>
  </div>
</template>

<style lang="scss">
.auth-notice {
  position: fixed;
  bottom: 20rem;
  right: 20rem;
  z-index: 10000;
  max-width: 480rem;
  padding: 16rem;
  background: #fff;
  color: #b00020;
  border: 1px solid currentColor;
  font-size: 16rem;
}
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
